export enum KYXEvents {
  START_BUTTON_CLICKED = "KYB Start Button Clicked",
  KYC_SUBMIT_PROCESSED = "KYB Submit Processed",
}
